import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from './en-US';
import jp from './ja-JP';

const resources = {
  en: {
    translation: en
  },
  jp: {
    translation: jp
  }
}

const localStorageGlobalConfigStore = window.localStorage.getItem('global-config-store');
const globalConfigStore = localStorageGlobalConfigStore ? JSON.parse(localStorageGlobalConfigStore) : ''

i18n.use(initReactI18next).init({
  resources,
  lng: globalConfigStore?.state?.language || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;